import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { PrimeReactProvider } from 'primereact/api';
import * as Sentry from "@sentry/react";
import FancyGlobalErrorBoundary from './FancyGlobalErrorBoundary.tsx';

Sentry.init({
  dsn: "https://3158abe90dd217127885a796f9867702@o4506447567781888.ingest.us.sentry.io/4508638269407232",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "prepbestie", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PrimeReactProvider>
      <FancyGlobalErrorBoundary>
        <App />
      </FancyGlobalErrorBoundary>
    </PrimeReactProvider>
  </StrictMode>,
)
